import CreateSVGIcon from './ad-studio-create-icon.svg';
import UploadSVGIcon from './ad-studio-upload-icon.svg';
import StockSVGIcon from './ad-studio-stock-icon.svg';
import InvestSVGIcon from './ad-studio-invest-icon.svg';
import PdfSVGIcon from './ad-studio-pdf-icon.svg';
import WarningSVGIcon from './ad-studio-warning-icon.svg';
import CreateManualBrandKitSVGIcon from './ad-studio-create-manual-icon.svg';
import WebsiteSVGIcon from './ad-studio-website-icon.svg';
import ImageEmptyViewSVG from './image-page-empty-view-image.svg';
import LibraryEmptyViewSVG from './library-page-empty-view-image.svg';
import VideoEmptyViewSVG from './video-page-empty-view-image.svg';
import AIWarningIconSource from './AIWarningIcon.png';
import ChooseImageSVG from './choose-image-icon.svg';
import LogoAssetsSvg from './logo-assets.svg';
import BrandKitLogoIconSVG from './ad-studio-brandkit-logo-icon.svg';

export const EntryCardSVGIcons = {
  CreateSVGIcon,
  UploadSVGIcon,
  StockSVGIcon,
  InvestSVGIcon,
  PdfSVGIcon,
  WebsiteSVGIcon,
  WarningSVGIcon,
  CreateManualBrandKitSVGIcon,
  BrandKitLogoIconSVG,
};

export { videoIcon } from './video-icon';
export { SparkeSVGIcon } from './sparkle-svg-icon';
export { HollowSparkleSVGIcon } from './hollow-sparkle-svg-icon';
export { BlackSparkleSVGIcon } from './black-sparkle-svg-icon';
export { InfoSparkleSVGIcon } from './info-sparkle-svg-icon';
export { SquareDismissIcon } from './squareDismiss-svg-icon';
export { SpinnerIcon } from './spinnerBase-svg-icon';


export const AIWarningIcon = AIWarningIconSource;
export const ChooseImageIcon = ChooseImageSVG;
export const LogoAssetsIcon = LogoAssetsSvg;

export const EmptyViewIcons = {
  ImageEmptyViewSVG,
  LibraryEmptyViewSVG,
  VideoEmptyViewSVG,
};
